// extracted by mini-css-extract-plugin
export default {"container":"Terms_container__6FUFc","anchor":"Terms_anchor__VxNDh","bold":"Terms_bold__Y74J4","divider":"Terms_divider__x7SMW"};